<!--
    * @Author: CaoJianBo
    * @Date: 2023-07-25 13:41:18
 * @LastEditors: jiaxiuc
 * @LastEditTime: 2024-04-12
    * @FilePath: \fe-crm\src\components\public\xl-export\xl-export.vue
   -->
<template>
  <div class="comp-xl-lead-in">
    <jw-modal :visible="visible" title-align="start" @cancel="handleCancel" unmount-on-close class="lead-in" @ok="handleOk" :title="$t('模板导入')">
      <jw-upload draggable :action="url" :limit="1" ref="uploadRef" @success="onSuccess" :headers="headers" @error="onError" accept=".xlsx" @before-upload="beforeUpload" @before-remove="beforeRemove" :auto-upload="false" :data="{ entity }">
        <template #upload-button>
          <div class="lead-in-content">
            <jw-space direction="vertical" fill>
              <icon-plus :style="{ color: 'var(--color-text-3)' }" />
              <span>{{ $t('点击或拖拽文件到此处上传') }}</span>
              <span :style="{ color: 'rgb(var(--danger-4))', fontSize: '12px' }">{{ $t('tips.onlyImporting') }}</span>
            </jw-space>
          </div>
        </template>
      </jw-upload>
      <template #footer>
        <div class="lead-in-footer">
          <jw-link @click="download"><icon-download />{{ $t('模板下载') }}</jw-link>
          <jw-space>
            <jw-button @click="handleCancel">{{ $t('取消') }}</jw-button>
            <jw-button type="primary" @click="handleOk" :loading="loading">{{ $t('导入') }}</jw-button>
          </jw-space>
        </div>
      </template>
    </jw-modal>
  </div>
</template>

<script>
import { reactive, toRefs, ref } from 'vue';
import { getToken } from '@/utils/auth';
import { Message } from '@arco-design/web-vue';
import { publicService, setService } from '@/api/';
import { tools } from '@/utils/tools';
import { useI18n } from 'vue-i18n';
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'XlLeadIn',
  setup(props, ctx) {
    const { t } = useI18n();
    console.log('1-开始创建组件-setup', props, ctx);
    console.log(props);
    const uploadRef = ref();
    const token = getToken() || null;
    const data = reactive({
      file: null,
      //   url: '/api/entity/upload/template_upload', //老接口
      url: '/api/entity/upload/upload/template', //新接口（根据模板导入）
      entity: '',
      excelTitle: '导入模板',
      loading: false,
      type: 'TEMPLATE',
      visible: false,
      status: false,
      headers: {
        authorization: `Bearer ${token}`
      }
    });
    const open = async (record) => {
      data.entity = record.entity;

      await getDownloadProgress();
      if (data.status) {
        await getTemplate(); //获取模板信息
        data.visible = true;
      } else {
        Message.warning(t('tips.uploadMessage'));
      }
    };
    //获取模板列表
    const getTemplate = async () => {
      const params = {
        entityId: data.entity
      };
      try {
        const json = await setService.getUploadTemplateList(params);
        if (json.error) {
          Message.error(json.error?.msg || t('操作失败'));
          return false;
        }
        data.excelTitle = json.result[0]?.template || '导入模板'; //模板的名称
      } catch (e) {
        console.log(e);
      }
    };
    // 点击取消
    const handleCancel = () => {
      data.visible = false;
    };
    // 点击导入
    const handleOk = (e) => {
      if (!data.file) {
        return Message.error(t('请选择文件'));
      }
      if (uploadMessage.value) {
        return Message.error(uploadMessage.value);
      }
      data.loading = true;
      e.stopPropagation();
      uploadRef.value.submit();
    };
    // 模板下载
    const download = () => {
      // 在此调用模板下载接口
      getLeadInTemplate();
    };
    // 模板下载接口
    const getLeadInTemplate = async () => {
      handleCancel();
      try {
        const res = await publicService.getLeadInTemplate({ entity: data.entity });
        // 获取模板
        tools.downLoad(res, data.excelTitle);
        data.status = res.result;
      } catch (e) {
        console.log('模板下载出错', e);
        Message.error(t('模板下载出错'));
      }
    };
    const uploadMessage = ref('');
    // 上传成功的回调
    const onSuccess = (fileItem) => {
      console.log('文件上传成功', fileItem);
      if (fileItem.response?.code !== 0) {
        console.info(data.file, 444);
        // uploadRef.value.updateFile();
        fileItem.status = 'error';
        uploadMessage.value = fileItem.response?.msg || t('导入出错');
        Message.error(uploadMessage.value);
        data.loading = false;
        return;
      }
      if (fileItem.status === 'done') {
        Message.success(t('tips.uploadAlert'));
        ctx.emit('cb');
      }
      data.loading = false;
      handleCancel();
    };
    // 获取当前进度接口
    const getDownloadProgress = async () => {
      try {
        const params = {
          type: data.type,
          entity: data.entity
        };
        const res = await publicService.getDownloadProgress(params);
        console.log('状态', res.result);
        data.status = res.result;
      } catch (e) {
        Message.error(e.message || e.statusText || t('获取当前进度失败'));
      }
    };
    // 上传失败的回调
    const onError = (fileItem) => {
      console.log('文件上传失败', fileItem);
      if (fileItem.status === 'error') {
        Message.error(t('上传失败'));
      }
      data.loading = false;
    };
    // 上传前效验文件大小
    const beforeUpload = (file) => {
      uploadMessage.value = '';
      data.file = file;
      // file.name.split('.')选择最后一个元素
      const fileTypeArray = file.name.split('.');
      const fileType = fileTypeArray.length > 0 && fileTypeArray[fileTypeArray.length - 1]; // 文件类型
      console.log('文件类型', fileType);
      if (fileType !== 'xlsx') {
        Message.error(t('上传文件格式不正确'));
        return false;
      }
      if (file.size / 1024 / 1024 < 20) {
        return true;
      } else {
        Message.error(t('tips.uploadFailedIsLarge'));
        return false;
      }
    };
    const beforeRemove = () => {
      data.file = null;
      uploadMessage.value = '';
      return true;
    };
    return {
      handleCancel,
      beforeUpload,
      beforeRemove,
      onSuccess,
      onError,
      open,
      handleOk,
      uploadRef,
      download, //模板下载
      ...toRefs(data)
    };
  }
};
</script>
<style scoped lang="less">
@import './xl-export.less';
</style>
